import utils from '@/assets/js/utils'
export default {
    filterStatus: val => {
        switch (Number(val)) {
            case 1:
                return '待支付';
                break;
            case 2:
                return '待处理';
                break;
            case 3:
                return '处理中';
                break;
            case 4:
                return '待确认';
                break;
            case 5:
                return '已完成';
                break;
            case 6:
                return '已撤单';
                break;
            case 7:
                return '已取消';
                break;
            case 8:
                return '已驳回';
                break;
            case 9:
                return '已退款';
                break;
            case 10:
                return '退款中';
                break;
            case 11:
                return '未解决';
                break
            case 13:
                return '已撤回';
                break
            default:
                return '';
                break
        }
    },

    filterRefund(val) {
    	switch(Number(val)){
    		case 1:
    			return "审核中";
    			break;
    		case 2:
    			return "通过";
    			break;
    		case 3:
    			return "拒绝";
    			break;
			default:
			    return '';
			    break
    	}
    },

    filterPay(val) {
        if (val == '微信支付') {
            return '微信钱包'
        } else if (val == '余额支付') {
            return '钱包余额'
        } else {
            return val
        }
    },
    
    filterFollowStatus(val){
    	if(val.is_add_user=="1"){
    		return "商家说"
    	}else if(val.is_add_user=="2"){
    		return "管理说"
    	}else if(val.is_add_user=="3"){
    		return utils.statusToName(val.order_status)
    	}
    }
};
